// class ProductOptions extends HTMLElement {
//     constructor() {
//         super();
//         this.isDispatchingEvent = false;
        
//     }
//     connectedCallback() {
//         this.available_variants = [],
//         this.container = this.querySelector(".product-options--container"),
//         this.first_variant = JSON.parse(this.querySelector("[id*=variant-first--json]").innerHTML),
//         this.inputs = this.container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]'),
//         this.is_product_page = null !== this.closest(".product-page--root"),
//         this.option_values = [],
//         this.size_chart = this.querySelector(".product-options--option .product-size-chart--root"),
//         this.variants = JSON.parse(this.querySelector("[id*=variant--json]").innerHTML),
//         this.getVariantOptions(),
//         this.hideOptions(this.first_variant, 0),
//         this.disableEmptyOptions(),
//         this.optionChangeListener(),
//         this.size_chart && this.moveSizeChart()
//     }
//     disconnectedCallback() {
//         this.inputs.off("change.ProductOptions")
//     }
//     getVariantOptions() {
//         if (this.variants.forEach(t => t.available && this.available_variants.push(t.options)),
//         0 < this.available_variants.length)
//             for (let i = 0; i < this.available_variants[0].length; i++)
//                 this.option_values[i] = [...new Set(this.available_variants.map(t => t[i]))]
//     }
//     disableEmptyOptions() {
//         const e = this.option_values.flat();
//         this.container.querySelectorAll(".radios--input, .disclosure--option").forEach(t => {
//             var i = this.getOptionValue(t);
//             e.includes(i) || t.setAttribute("data-empty", !0)
//         }
//         )
//     }

//     findSelectAvailableOption(options) {
//       if (options.length < 2 || this.isDispatchingEvent) return;
      
//       const option1Value = options.find(o => o.index == '0').value;
//       const availableOption2 = this.available_variants.find(o => o[0] == option1Value)[1];
      
//       if(!availableOption2) return;

//       const radioElement = this.container.querySelector(`[type="radio"][value="${availableOption2}"]`);
//       if (!radioElement) {
//         console.error(`Radio element not found for value: ${availableOption2}`);
//         return;
//       }

//       this.isDispatchingEvent = true;
    
//       // Dispatch the event
//       radioElement.checked = true; // Set the element as checked
//       radioElement.dispatchEvent(new Event('change', { bubbles: true }));

//       this.isDispatchingEvent = false;
      
//     }
  
//     optionChangeListener() {
//         this.inputs.forEach(input => 
//             input.addEventListener("change", (event) => {
//                 const selections = [];
//                 this.container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]:checked').forEach(selected => {
//                     const index = selected.closest(".product-options--option").dataset.index;
//                     selections.push({ index, value: selected.value });
//                 });

//                 this.hideOptions(selections.map(s => s.value), event.target.closest(".product-options--option").dataset.index);
                
//                 let matchedVariant = null;
//                 this.variants.every(variant => {
//                     const isMatch = selections.every(sel => variant.options[sel.index] === sel.value);
//                     if (isMatch) {
//                         matchedVariant = variant;
//                         return false;
//                     }
//                     return true;
//                 });

//                 this.updateVariant(matchedVariant);
//                 if(event.target.closest(".product-options--option").dataset.index == 0)
//                   this.findSelectAvailableOption(selections);
//             })
//         );
//     }
  
//     updateVariant(t) {
//         this.is_product_page && this.updateHistoryState(t.id),
//         window.trigger(`theme:product:${this.dataset.id}:variantChanged`, {
//             variant: t
//         })
//     }
//     updateHistoryState(t) {
//         let i = "" + location.origin + location.pathname;
//         t && (i += "?variant=" + t),
//         history.replaceState({
//             path: i
//         }, "", i)
//     }
//     hideOptions(a, i) {
//         const s = 0 === this.option_values.length ? [] : a.map( (t, e) => this.option_values[e].filter(t => {
//             const i = [...a];
//             return i[e] = t,
//             this.available_variants.some(t => t.join(",") === i.join(","))
//         }
//         ));
//         this.container.childNodes.forEach( (t, e) => {
//             e != i && t.querySelectorAll(".radios--input, .disclosure--option").forEach(t => {
//                 var i = this.getOptionValue(t);
//                 t.setAttribute("data-unavailable", !s[e].includes(i))
//             }
//             )
//         }
//         )
//     }
//     getOptionValue(t) {
//         return t.getAttribute("data-value") ? t.getAttribute("data-value") : t.value
//     }
//     moveSizeChart() {
//         this.size_chart.parentNode.querySelector("label").parentNode.appendChild(this.size_chart),
//         this.size_chart.removeAttribute("style")
//     }
// }

// document.addEventListener("DOMContentLoaded", (event) => {
//     const productOptionsEl = customElements.get("product-options-root");
//     productOptionsEl || customElements.define("product-options-root", ProductOptions);
// });



class ProductOptions extends HTMLElement {
    constructor() {
        super();
        this.isDispatchingEvent = false;
    }

    connectedCallback() {
        this.available_variants = [];
        this.container = this.querySelector(".product-options--container");
        this.first_variant = JSON.parse(
            this.querySelector("[id*=variant-first--json]").innerHTML
        );
        this.inputs = this.container.querySelectorAll(
            '[data-item="disclosure"], [data-item="radio"]'
        );
        this.is_product_page = null !== this.closest(".product-page--root");
        this.option_values = [];
        this.size_chart = this.querySelector(
            ".product-options--option .product-size-chart--root"
        );
        this.variants = JSON.parse(
            this.querySelector("[id*=variant--json]").innerHTML
        );

        this.getVariantOptions();
        this.hideOptions(this.first_variant, 0);
        this.disableEmptyOptions();
        this.optionChangeListener();

        if (this.size_chart) {
            this.moveSizeChart();
        }
    }

    disconnectedCallback() {
        if (!this.inputs) return;

        this.inputs.forEach(input => {
            if (input._productOptionsChangeHandler) {
                input.removeEventListener(
                    "change",
                    input._productOptionsChangeHandler
                );
                delete input._productOptionsChangeHandler;
            }
        });
    }

    getVariantOptions() {
        this.variants.forEach(variant => {
            if (variant.available) {
                this.available_variants.push(variant.options);
            }
        });

        if (this.available_variants.length > 0) {
            for (let i = 0; i < this.available_variants[0].length; i++) {
                this.option_values[i] = [
                    ...new Set(
                        this.available_variants.map(variant => variant[i])
                    )
                ];
            }
        }
    }

    disableEmptyOptions() {
        const values = this.option_values.flat();

        this.container
            .querySelectorAll(".radios--input, .disclosure--option")
            .forEach(option => {
                const value = this.getOptionValue(option);

                if (!values.includes(value)) {
                    option.setAttribute("data-empty", "true");
                }
            });
    }

    findSelectAvailableOption(options) {
        if (options.length < 2 || this.isDispatchingEvent) return;

        const option1 = options.find(
            option => Number(option.index) === 0
        );
        const option2 = options.find(
            option => Number(option.index) === 1
        );

        if (!option1 || !option2) return;

        const currentVariant = this.variants.find(variant =>
            variant.available &&
            variant.options[0] === option1.value &&
            variant.options[1] === option2.value
        );

        if (currentVariant) return;

        const fallbackVariant = this.variants.find(variant =>
            variant.available &&
            variant.options[0] === option1.value
        );

        if (!fallbackVariant) return;

        const radioElement = Array.from(
            this.container.querySelectorAll('input[type="radio"]')
        ).find(radio =>
            radio.value === fallbackVariant.options[1] &&
            Number(
                radio.closest(".product-options--option")?.dataset.index
            ) === 1
        );

        if (!radioElement || radioElement.checked) return;

        this.isDispatchingEvent = true;

        try {
            radioElement.checked = true;
            radioElement.dispatchEvent(
                new Event("change", { bubbles: true })
            );
        } finally {
            this.isDispatchingEvent = false;
        }
    }

    optionChangeListener() {
        this.inputs.forEach(input => {
            const handler = event => {
                if (this.isDispatchingEvent) return;

                const selections = [];

                this.container
                    .querySelectorAll(
                        '[data-item="disclosure"], [data-item="radio"]:checked'
                    )
                    .forEach(selected => {
                        const option = selected.closest(
                            ".product-options--option"
                        );

                        if (!option) return;

                        selections.push({
                            index: Number(option.dataset.index),
                            value: selected.value
                        });
                    });

                const changedOption = event.target.closest(
                    ".product-options--option"
                );

                if (changedOption) {
                    this.hideOptions(
                        selections.map(selection => selection.value),
                        Number(changedOption.dataset.index)
                    );
                }

                const matchedVariant = this.variants.find(variant =>
                    selections.every(selection =>
                        variant.options[selection.index] === selection.value
                    )
                );

                if (matchedVariant) {
                    this.updateVariant(matchedVariant);
                }

                if (
                    changedOption &&
                    Number(changedOption.dataset.index) === 0
                ) {
                    this.findSelectAvailableOption(selections);
                }
            };

            input._productOptionsChangeHandler = handler;
            input.addEventListener("change", handler);
        });
    }

    updateVariant(variant) {
        if (!variant) return;

        if (this.is_product_page) {
            this.updateHistoryState(variant.id);
        }

        window.trigger(
            "theme:product:" + this.dataset.id + ":variantChanged",
            { variant: variant }
        );
    }

    updateHistoryState(id) {
        let url = "" + location.origin + location.pathname;

        if (id) {
            url += "?variant=" + id;
        }

        history.replaceState({ path: url }, "", url);
    }

    hideOptions(values, changedIndex) {
        const unavailableValues = values.length === 0
            ? []
            : values.map((value, index) => {
                return this.option_values[index].filter(optionValue => {
                    const candidate = [...values];
                    candidate[index] = optionValue;

                    return this.available_variants.some(variant =>
                        variant.every(
                            (variantValue, variantIndex) =>
                                variantValue === candidate[variantIndex]
                        )
                    );
                });
            });

        this.container.childNodes.forEach((child, index) => {
            if (index === changedIndex) return;
            if (!child.querySelectorAll) return;

            child
                .querySelectorAll(".radios--input, .disclosure--option")
                .forEach(option => {
                    const value = this.getOptionValue(option);
                    const available = unavailableValues[index] || [];

                    option.setAttribute(
                        "data-unavailable",
                        String(!available.includes(value))
                    );
                });
        });
    }

    getOptionValue(element) {
        return element.getAttribute("data-value")
            ? element.getAttribute("data-value")
            : element.value;
    }

    moveSizeChart() {
        this.size_chart.parentNode
            .querySelector("label")
            .parentNode.appendChild(this.size_chart);

        this.size_chart.removeAttribute("style");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const productOptionsElement = customElements.get(
        "product-options-root"
    );

    if (!productOptionsElement) {
        customElements.define("product-options-root", ProductOptions);
    }
});